import React, {useState} from "react";
import "../../css/about/contacts.css"
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import Navigation from "../utils/Navigation";
import SeoHelmet from "../utils/seo"
import {useLocation} from "react-router-dom";
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import {useTheme} from "../header/Header";

export default function Contacts() {

    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname)
    const seo = siteData !== null && siteData.seo? siteData.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme();

    return (
        <div className={`overlay`}>
            <SeoHelmet title={seo.title} description={seo.description}/>
            <Navigation/>
            <div className={`complexBack ${theme}`}> </div>

            <div className={`contacts-container ${theme}`}>
                <h1 className={"contacts-title"}>Контакты</h1>
                <MapContact/>

                <div className="contacts-office">
                    <h3 className="contacts-section-title">Офис продаж Чебоксары</h3>
                    <div className="contacts-office-info">
                        <p>Адрес: <span className="contacts-link">Чебоксары Ленинградская 36</span></p>
                        <p>Е-mail: <span className="contacts-link">zaosespel@yandex.ru</span></p>
                        <p>Тел./факс: +7 (800) 551-16-34 (многоканальный)</p>
                        <p>Тел./факс: +7 (8352) 22-57-22 (городской)</p>
                    </div>
                </div>

                <div className={"contacts-plant"}>
                    <div className={`contacts-section ${theme}`}>
                        <h3>Адрес завода</h3>
                        <p>
                            Адрес: <span className="contacts-link">Сидуковская улица, 39, деревня Сидуккасы, Моргаушский район, Чувашская Республика</span>
                        </p>
                    </div>

                    <div className={`contacts-section ${theme}`}>
                        <h3>Реквизиты компании:</h3>
                        <p>Наименование: ЗАО "Чебоксарское предприятие "Сеспель"</p>
                        <p>ИНН: 2126002786</p>
                        <p>КПП: 213001001</p>
                        <p>ОГРН: 1022101277934</p>
                    </div>
                </div>
                <div className={"contacts-plant"}>
                    <div className={`contacts-section ${theme}`}>
                        <h3>Стоянка техники в наличии - Официальный дилер</h3>
                        <p>
                            Адрес: <span className="contacts-link">Моргаушский район, д. Тереси, ул. Новая, дом 71</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function MapContact() {
    const [activeHint, setActiveHint] = useState(null); // null означает, что подсказка не открыта
    const { theme } = useTheme()

    // Данные для меток и подсказок
    const placemarks = [
        {
            id: 1,
            coordinates: [56.137945, 47.245739],
            hint: "Чебоксары Ленинградская 36",
        },
        {
            id: 2,
            coordinates: [56.040978, 46.808087],
            hint: "Моргаушский район, д. Тереси, ул. Новая, дом 71",
        },
        {
            id: 3,
            coordinates: [56.041734, 46.765147],
            hint: "Сидуковская улица, 39, деревня Сидуккасы, Моргаушский район, Чувашская Республика",
        },
    ];

    return (
        <div className={`contacts-map ${theme}`}>
            <YMaps>
                <Map
                    defaultState={{
                        center: [56.117945, 46.9],
                        zoom: 10,
                    }}
                    width="100%"
                    height="300px"
                    options={{
                        suppressMapOpenBlock: true,
                    }}
                >
                    {/* Отображаем все метки и подсказки */}
                    {placemarks.map((placemark) =>
                        activeHint === placemark.id ? (
                            <div
                                key={placemark.id}
                                style={{
                                    position: "absolute",
                                    transform: "translate(-50%, -100%)",
                                    left: "50%",
                                    top: "50%",
                                    color: "black",
                                    backgroundColor: "white",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <span>{placemark.hint}</span>
                                    <button
                                        onClick={() => setActiveHint(null)} // Закрыть подсказку
                                        style={{
                                            marginLeft: "10px",
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        ✖
                                    </button>
                                </div>
                            </div>
                        ) : (
                            !activeHint && (
                                <Placemark
                                    key={placemark.id}
                                    geometry={placemark.coordinates}
                                    onClick={() => setActiveHint(placemark.id)} // Открыть подсказку
                                />
                            )
                        )
                    )}
                </Map>
            </YMaps>
        </div>
    );
}

